import { Box, Typography } from "@mui/material";
import cours from "../../images/cours/cours1_resized.jpg";
import { DayCards } from "./components/day-cards";
import { PricingCards } from "./components/pricing-cards";
import { CLASSES_PRIMARY_TEXT, CLASSES_SECONDARY_TEXT } from "./shared";

export function ClassesPage() {
  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          backgroundImage: `url(${cours})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: { xs: "40vh", md: "50vh" },
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        <Box sx={{ position: "absolute", inset: 0, backgroundColor: "rgba(0,0,0,0.55)" }} />
        <Typography
          variant="h2"
          sx={{
            position: "relative",
            color: "#fff",
            px: { xs: 3, md: 8 },
            pb: 4,
          }}
        >
          Nos cours
        </Typography>
      </Box>

      <Box sx={{ px: { xs: 3, md: 8 }, py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          {CLASSES_PRIMARY_TEXT}
        </Typography>
        <Typography variant="body1" color="text.secondary" mt={2}>
          {CLASSES_SECONDARY_TEXT}
        </Typography>
      </Box>

      <Box sx={{ px: { xs: 3, md: 8 }, pb: 6 }}>
        <Typography variant="h5" gutterBottom>
          Horaire
        </Typography>
        <DayCards />
      </Box>

      <Box sx={{ px: { xs: 3, md: 8 }, pb: { xs: 4, md: 8 } }}>
        <Typography variant="h5" gutterBottom>
          Tarifs
        </Typography>
        <PricingCards />
      </Box>
    </Box>
  );
}
